<template>
  <div class="my-pages-container">
    <div class="my-pages-container__layout">
      <oie-aside-navigation
        v-if="showAsideMenu"
        class="my-pages-container__aside"
        :children="children"
        :active-child="activeComponent"
        @click="setActiveComponent"></oie-aside-navigation>
      <main v-if="activeComponent && showMainContent" class="my-pages-container__main">
        <component :is="clientModel.isAuthenticated ? activeComponent.key : 'oie-my-pages-login'"></component>
      </main>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import utils from '@/core/utils'

export const SUB_PAGES = {
  oieMyShoppingList: { key: 'oie-my-shopping-list', name: 'Shopping list' },
  oieAddOrEditMachineOwner: { key: 'oie-add-edit-machine-owner', name: 'Add or edit machine owner' },
  oieAddOrEditMachine: { key: 'oie-add-edit-machine', name: 'Add or edit machine' },
  oieMachineOwnerDetails: { key: 'oie-machine-owner-details', name: 'Machine owner details' },
  oieMachineDetails: { key: 'oie-machine-details', name: 'Machine details' },
  oieMyMachineSettings: { key: 'oie-my-machine-settings', name: 'My machine settings' },
  oieInvoiceHistoryDetails: { key: 'oie-my-invoice-history-details', name: 'Invoice details' },
  oieEditUser: { key: 'oie-edit-user', name: 'Edit user' }
}

export default {
  props: {
    children: {
      type: Array,
      required: true
    }
  },
  provide() {
    return {
      navigationOptions: this.navigationOptions,
      navigationHistory: this.navigationHistory
    }
  },
  data() {
    return {
      activeComponent: null,
      navigationHistory: []
    }
  },
  computed: {
    showMainContent() {
      return this.mq('medium') || this.activeComponent
    },
    showAsideMenu() { return (this.mq('medium') && !this.isFullWidthSubPage) ? true : !this.activeComponent },
    navigationOptions() {
      const childrenDictionary = _.chain(this.children).mapKeys(obj => _.camelCase(obj.key)).value()
      return { ...childrenDictionary, ...SUB_PAGES }
    },
    isFullWidthSubPage() {
      return this.activeComponent && this.activeComponent.key === this.navigationOptions.oieMyShoppingList.key
    }
  },
  watch: {
    activeComponent() {
      if(this.activeComponent) {
        window.location.hash = this.activeComponent.name
      } else {
        var urlWithoutFragment = window.location.href.split('#')[0]
        utils.pushState(urlWithoutFragment)
      }

      this.navigationHistory.push(this.activeComponent)
    }
  },
  mounted() {
    this.setInitialActiveComponent()
    this.subscribe('my-pages-set-active-component', (component) => {
      this.setActiveComponent(component)
    })
    this.subscribe('my-pages-go-back', () => {
      this.navigateBack()
    })
  },
  methods: {
    setActiveComponent(child) {
      this.activeComponent = child
      window.scrollTo(0, 0)
    },
    setInitialActiveComponent() {
      const hash = decodeURIComponent(window.location.hash.replace('#', ''))
      const matchingChild = _.find(this.navigationOptions, option => option.name === hash)
      if(matchingChild) {
        this.setActiveComponent(matchingChild)
      } else {
        if(this.mq('medium')) {
          this.activeComponent = _.first(this.children)
        }
      }
    },
    navigateBack(initial = 0) {
      const goBack = -2 + initial
      const prev = _.nth(this.navigationHistory, goBack)
      if(this.isRetraceable(prev)) {
        const lastNavs = this.navigationHistory.splice(goBack)
        const newNav = _.head(lastNavs)
        this.setActiveComponent(newNav)
      } else {
        this.navigateBack(initial - 1)
      }
    },
    // Some pages (ex add new machine) are not meant to be accessible by "Back" button
    isRetraceable(component) {
      return component.key !== SUB_PAGES.oieAddOrEditMachine.key
    }
  }
}

</script>

<style lang="scss">
.my-pages-container {
  @include container;
  padding-top: calc(#{measure(double)} + 1rem);
  padding-bottom: measure(double);
}

.my-pages-container__layout {
  display: flex;
}

.my-pages-container__aside {
  flex: 1 0 20rem;
  margin-right: measure(half);
}

.my-pages-container__main {
  flex: 1 1 100%;
  overflow: auto;
}
</style>
